module.exports = __webpack_public_path__ + "img/Pinata_pour_mariage.bae3d8d.jpg";